export const forgotPhoneFields = {
  phone: {
    value: '',
    error: null,
    name: 'phone',
    placeholder: 'Phone',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'phone',
    hasBlurred: false,
    inputType: 'text',
  }
}

export const forgotEmailFields = {
  email: {
    value: '',
    error: null,
    name: 'email',
    placeholder: 'Email Address',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'email',
    hasBlurred: false,
    inputType: 'text',
  }
}



/** WEBPACK FOOTER **
 ** ./src/forms/member/forgot.js
 **/